import { useTranslation } from 'react-i18next';
import React from 'react';
import { GetUsersResponse } from '../../../../modules/backend/openapi/api-types';
import { GridContainer, GridItem } from '../../../../visual-components/grid/grid';
import { useSelfQuery } from '../../../../modules/user/queries';
import { Link } from '../../../../visual-components/link/link';
import { usePathBuilder } from '../../../../core/routing/hooks/use-path-builder';
import { Spacer } from '../../../../visual-components/spacer/spacer';
import { UserTable, useUserTableColumnDefinition } from '../../../../modules/table/user-table';

type Props = {
  data: GetUsersResponse;
  companyName: string;
};

export const UserList: React.FC<Props> = ({ data: { items: users }, companyName }) => {
  const { t } = useTranslation();
  const { formNewUserForExistingCustomer } = usePathBuilder();

  const { data: selfUser, isLoading, isLoadingError } = useSelfQuery();
  const isCustomerAdmin = selfUser?.data?.isCustomerAdmin;
  const colDef = useUserTableColumnDefinition({ isCustomerAdmin });

  return (
    <>
      <Spacer size="06" />
      <GridContainer>
        <GridItem>
          <UserTable colDef={colDef} hasError={isLoadingError} isLoading={isLoading} users={users} />
          {isCustomerAdmin ? (
            <>
              <Spacer size="06" />
              <Link icon="pen-box" to={formNewUserForExistingCustomer(companyName)}>
                {t('profile.settings.askForAdditionalUserAccount')}
              </Link>
            </>
          ) : null}
        </GridItem>
      </GridContainer>
    </>
  );
};
